app.service('kredytLineRedirect', function (loading, modal, message, console) {
	var isBlocked = false;
	var timeout = 1200;
	var revisions = 3;

	function showNKLError() {
		message.get('nkl-init-error-message').then(function (html) {
			loading.stop();
			modal.generate({
				id: 'nkl-init-error',
				content: html
			});
		});
	}

	function redirect(data, params) {
		var redirectData = {
			orderNumber: data.orderNumber
		}
		if (params) {
			timeout = params.timeout;
			revisions = params.revisions;
		}
		if (data._csrf) {
			redirectData._csrf = data._csrf;
		}
		if (isBlocked) {
			console.log('Blokada przejścia do wniosku ratalnego');
			return
		}
		isBlocked = true;
		if (!modal.isOpen('kredytLine-count')) {
			loading.start();
		}
		$.ajax({
			type: 'POST',
			url: '/kredytline-application-init.ltr',
			data: redirectData,
			success: function (json) {
				isBlocked = false;
				if (json.status === 'SUCCESS' && json.url) {
					modal.close('kredytLine-count');
					loading.redirect({
						href: json.url,
						soft: false
					});
				} else {
					revisions--;
					if (revisions > 0) {
						setTimeout(function () {
							redirect(data);
						}, timeout);
					} else {
						showNKLError();
					}
				}
			},
			error: function () {
				isBlocked = false;
				showNKLError();
			}
		});
	}

	function check(orderNr, actionName, callback) {
		if (!isBlocked) {
			isBlocked = true;
			loading.start();
			$.ajax({
				url: '/customer-action-refresh.ltr',
				cache: false,
				type: 'POST',
				data: {
					orderNumber: orderNr,
					action: actionName
				},
				success: function (htmlData) {
					isBlocked = false;
					loading.stop();
					if (htmlData.trim() != '') {
						modal.alert(htmlData);
					} else {
						callback();
					}
				},
				error: function () {
					isBlocked = false;
					loading.stop();
					modal.alert('Wystąpił problem z połączeniem. Proszę spróbować później.');
				}
			});
		} else {
			console.log('Blokada sprawdzania wniosku');
		}
	}

	return {
		redirect,
		check
	};
});
